import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface CellOriginalLinkedIconProps {
  isSelected?: boolean;
  numLinkedConversations?: number;
}

/*
 * Style.
 */

const StyledTooltipCoordinator = styled(TooltipCoordinator)`
  margin-left: 6px;
`;

/*
 * Component.
 */

export const CellOriginalLinkedIcon: FC<CellOriginalLinkedIconProps> = ({
  isSelected,
  numLinkedConversations,
}) => {
  const theme = useUserTheme();
  const iconColor = isSelected ? theme.invertedIcon : theme.greys.shade70;
  if (!numLinkedConversations || numLinkedConversations === 0) {
    return null;
  }

  return (
    <StyledTooltipCoordinator
      render={() => (
        <Plural
          id="cell-original-conversation-icon-tooltip"
          value={numLinkedConversations}
          one="# conversation linked"
          other="# conversations linked"
        />
      )}
    >
      <Icon name="linkedConversationsFilledSmall" color={iconColor} />
    </StyledTooltipCoordinator>
  );
};
